"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";

import { useAppSelector } from "@/redux/store";
import { SelectLoggedUser } from "@/redux/Auth";
import MyLink from "@/components/shared/myLink/MyLink";
import heroIllustration from "@/public/images/start.png";

const HeroHome = ({ home }: any) => {
  const [showFilter, setshowFilter] = useState(false);
  const loggedUser = useAppSelector(SelectLoggedUser);

  return (
    <div className="w-full flex flex-col md:flex-row items-center justify-center gap-10 md:gap-0 relative z-10">
      {/* Text Content */}
      <div className="flex-1 flex flex-col items-center md:items-center text-center md:text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight text-white drop-shadow-lg">
          منصتك الأولى
          <span className="text-primaryColor"> للنجاح </span>
          في التعليم
        </h1>
        <p className="text-lg md:text-2xl text-[#C7D0E0] mb-8 max-w-xl">
          منصة Eduegoo تهدف إلى تطوير العملية التعليمية ومساعدة الطلاب على تحقيق
          التفوق في جميع المواد من خلال خدمات تعليمية متكاملة وحديثة.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 w-full md:justify-center justify-center">
          {loggedUser.isLoggedIn && loggedUser.userToken ? (
            <>
              <MyLink
                href="/courses"
                className="bg-primaryColor text-white font-semibold py-3 px-8 rounded-lg shadow-md bg-opacity-80 transition"
              >
                عرض الكورسات
              </MyLink>
              <MyLink
                href="/fullExams"
                className="bg-[#1b252f] text-primaryColor font-semibold py-3 px-8 rounded-lg border border-primaryColor shadow-md hover:text-white transition"
              >
                عرض الاختبارات الشاملة
              </MyLink>
              <MyLink
                href="/books"
                className="bg-[#232c37] text-white font-semibold py-3 px-8 rounded-lg border border-white shadow-md hover:bg-primaryColor hover:text-white transition"
              >
                شراء كتب
              </MyLink>
            </>
          ) : (
            <>
              <MyLink
                href="/signup"
                className="bg-primaryColor text-white font-semibold py-3 px-8 rounded-lg shadow-md bg-opacity-80 transition"
              >
                أنشئ حسابك الآن
              </MyLink>
              <MyLink
                href="/courses"
                className="bg-[#1b252f] text-primaryColor font-semibold py-3 px-8 rounded-lg border border-primaryColor shadow-md hover:text-white transition"
              >
                تصفح الكورسات
              </MyLink>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroHome;
